export function hash(str: string) {
  return Array.from(str).reduce(
    // eslint-disable-next-line no-bitwise
    (acc, char) => (Math.imul(31, acc) + char.charCodeAt(0)) | 0,
    0
  );
}

/**
 * Получая строку вида "г Геленджик, ул Херсонская, д 70"
 * Превращаем ее в "ггеленджикулхерсонскаяд70"
 * Далее то же самое делаем с поисковым адресом который вводит пользователь
 * и ищем совпадение по вхождению подстроки
 * таким образом любой ввод пользователя нормально будет матчиться (даже если он где-то пробел пропустил)
 * @param str входная строка
 * @returns преобразованная поисковая строка
 */
export function getSearchInvariantString(str: string) {
  // remove all spaces, commas and make lowercase
  return str.trim().replace(/[\s,]/g, '').toLowerCase();
}
